import React from 'react';

const AVATAR_COLORS = ['#62794E', '#3E6B8A', '#8A5A3E', '#6B4E8A', '#8A3E5A', '#3E8A6E'];

function getInitials(name) {
  const trimmed = (name || '').trim();
  if (!trimmed) return '?';
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function colorFor(key) {
  let hash = 0;
  for (let i = 0; i < key.length; i++) hash = key.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export default function AssigneeAvatars({ assignees = [], team = [], max = 4 }) {
  if (!assignees || assignees.length === 0) return null;

  const visible = assignees.slice(0, max);
  const overflow = assignees.length - visible.length;

  return (
    <div className="assignee-avatars">
      {visible.map((email) => {
        const member = team.find((m) => m.email === email);
        const name = member?.name || email;
        return (
          <span
            key={email}
            className="assignee-avatar"
            style={{ background: colorFor(email) }}
            title={name}
          >
            {getInitials(name)}
          </span>
        );
      })}
      {overflow > 0 && (
        <span className="assignee-avatar assignee-avatar-overflow" title={`+${overflow} more`}>
          +{overflow}
        </span>
      )}
    </div>
  );
}
